import { render, staticRenderFns } from "./OfferAvatar.vue?vue&type=template&id=72df6a5e&scoped=true"
import script from "./OfferAvatar.vue?vue&type=script&lang=ts"
export * from "./OfferAvatar.vue?vue&type=script&lang=ts"
import style0 from "./OfferAvatar.vue?vue&type=style&index=0&id=72df6a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df6a5e",
  null
  
)

export default component.exports